import { HttpClient } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfigService } from "@fuse/services/config.service";
import { UiService } from "app/helper-components/UiService";
import { HelperService } from "app/helpers/helper.service";
import { LogoutService } from "app/helpers/logout.service";
import { UserDataService } from "app/helpers/user-data.service";
import { environment } from "environments/environment";
import { AlertsService } from "../alerts-welcome/alerts.service";

@Component({
  selector: "app-election-list",
  templateUrl: "./election-list.component.html",
  styleUrls: ["./election-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class ElectionListComponent implements OnInit, AfterViewInit {
  parameters: any = {};

  constructor(
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private _fuseConfigService: FuseConfigService,
    private router: Router,
    private uiService: UiService,
    private http: HttpClient,
    private logoutService: LogoutService,
    private userDataService: UserDataService,
    private alertsService: AlertsService
  ) {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
    });
    localStorage.removeItem("dataSource");
  }

  ngAfterViewInit(): void {}

  selectElection(election) {
    localStorage.setItem("elc", election.election_id);

    this.uiService.showLoading();

    const formData = new FormData();
    formData.append("getLoginUserData", "1");

    this.http.post(environment.API_URL, formData).subscribe((val: any) => {
      this.logoutService.initTimer();
      this.userDataService.userData = val;
      this.userDataService.startServerTime(val.time);

      // Check for Alerts
      if (this.userDataService.userData?.party_posts.length ?? 0 > 0)
        this.alertsService.fetchAlerts().subscribe((alert) => {
          this.uiService.showLoading();

          this.alertsService.alertData = alert.data;
          if (this.alertsService.alertData != "") {
            this.router.navigate(["/alerts-welcome"]);
          } else {
            this.router.navigate(["/user/member_view", val.id]);
          }
        });
      else {
        this.uiService.showLoading();
        this.router.navigate(["/user/member_view", val.id]);
      }
    });
    // this.router.navigate([
    //   "/user/member_view",
    //   this.loginForm.controls.username.value,
    // ]);
  }
}
